import script from "./EmployeeDashboardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployeeDashboardView.vue?vue&type=script&setup=true&lang=ts"

import "./EmployeeDashboardView.vue?vue&type=style&index=0&id=74aeda13&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74aeda13"]])

export default __exports__